// These map to states in the API
export const UPLOAD_STATES = {
  PENDING: 'Pending',
  CREATED: 'Created',
  QUEUED: 'Queued',
  PROCESSING: 'Running',
  INGESTED: 'Ingested',
  REVIEW: 'Ingestedalt',
  MIGRATING: 'Migrating',
  DONE: 'Migrated',
  ERROR: 'Error',
};

export const IN_PROGRESS_STATES = [
  UPLOAD_STATES.CREATED,
  UPLOAD_STATES.QUEUED,
  UPLOAD_STATES.PENDING,
  UPLOAD_STATES.PROCESSING,
  UPLOAD_STATES.INGESTED,
  UPLOAD_STATES.REVIEW,
  UPLOAD_STATES.MIGRATING,
];

export const FEATURE_STATE = {
  ALTERNATE: 'k', // alternate feature requiring approval
  APPROVED: 'a',
  DISCARDED: 'd',
  ERROR: 'e',
};

export const APPROVAL_OUTCOMES = {
  ACCEPT: 'a',
  DISCARD: 'd',
};

// labels that display a little extra context to users.
export const UPLOAD_LABELS = {
  [UPLOAD_STATES.CREATED]: 'Pending',
  [UPLOAD_STATES.QUEUED]: 'Pending',
  [UPLOAD_STATES.PENDING]: 'Pending',
  [UPLOAD_STATES.PROCESSING]: 'Processing',
  [UPLOAD_STATES.INGESTED]: 'Ready',
  [UPLOAD_STATES.REVIEW]: 'Ready',
  [UPLOAD_STATES.MIGRATING]: 'Creating collection',
  [UPLOAD_STATES.DONE]: 'Done',
  [UPLOAD_STATES.ERROR]: 'Error',
};
